module.exports = __webpack_public_path__ + "static/media/dv360.b08ef77b.png";